module.exports = __webpack_public_path__ + "img/groenkaal_prep.0b9150cf.jpg";